import React, { useMemo } from 'react';
import { GenericItem } from '@marty-js/api-sdk/types';
import styled from 'styled-components';
import { Menu, MenuLink } from './menu';

const MenuContainer = styled.div`
  grid-column: 1 / 10;
  padding-bottom: var(--spacer-s);
`;

interface Props {
  itemList?: GenericItem[];
}

export function DedicatedItemMenu({ itemList }: Props) {
  const dedicatedLinks = useMemo(() => {
    return (
      itemList
        ?.map((dedicatedItem: GenericItem): MenuLink => {
          if (!dedicatedItem?.url) {
            return null;
          }

          return {
            href: dedicatedItem.url,
            label: dedicatedItem.title,
          };
        })
        ?.filter(Boolean) || null
    );
  }, [itemList]);

  if (dedicatedLinks && dedicatedLinks.length > 0) {
    return (
      <MenuContainer>
        <Menu links={dedicatedLinks} />
      </MenuContainer>
    );
  }

  return null;
}
